import React, { useState, useContext, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../authmanager/authcontext";
import { getcheckoutCart,createOrder ,verifyPayment} from "../utils/utils";
import Navbar from "../navbar/navbar";
import axios from 'axios';

const Payments = ({ toggleTheme }) => {
  const navigate = useNavigate();
  const [checkoutResponse, setCheckOutResponse] = useState([]);
  const [success, setSuccessMessage] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { isLoggedIn, handleLogout, finalizeCart } = useContext(AuthContext);
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    const handlePayment = async () => {
      try {
        setIsLoading(true);
        // Fetch the cart items
        let cart = await getcheckoutCart(accessToken);
        console.log(cart);
        setCheckOutResponse(cart);
      } catch (error) {
        console.error("Error:", error.message);
        setError("An error occurred while fetching the checkout details.");
      } finally {
        setIsLoading(false);
      }
    };

    if (isLoggedIn) {
      handlePayment();
    }
  }, [accessToken, isLoggedIn]);

  // Function to find the latest order by ID
  const getLatestOrder = (orders) => {
    if (orders.length === 0) return null;
    return orders.reduce((latest, current) =>
      (current.id > latest.id ? current : latest), orders[0]
    );
  };

  // Get the latest order from the checkoutResponse
  const latestOrder = getLatestOrder(checkoutResponse);

  // Razorpay Payment Handler
  const handleRazorpayPayment = async (order) => {
    try {
      // Call your Django backend to create an order
      let orderAmount = order.amount 
      let receipt = order.id
      const orderResponse = await createOrder(orderAmount, receipt);
      const { order_id, razorpay_amount, currency,key } = orderResponse;

      // Options for Razorpay Checkout
      const options = {
        key: key, // Replace this with your Razorpay Key ID
        amount: razorpay_amount,
        currency: currency,
        name: "Your Company Name",
        description: "Test Transaction",
        order_id: order_id,
        handler: async function (response) {
          // On successful payment, verify payment
          const razorpayOrderId= response.razorpay_order_id
          const razorpayPaymentId= response.razorpay_payment_id
          const razorpaySignature= response.razorpay_signature
          const itemOrderId = order.id
        
          const verifyResponse = await verifyPayment(itemOrderId,razorpayOrderId, razorpayPaymentId, razorpaySignature);
          console.log(verifyResponse)
          if (verifyResponse.status === "Payment successful") {
            setSuccessMessage(true);
            window.location.reload(); 
          } else {
            setError("Payment verification failed.");
          }
        },
        prefill: {
          name: latestOrder.name || "Test User",
          email: latestOrder.email || "test@example.com",
          contact: latestOrder.phone || "9999999999"
        },
        theme: {
          color: "#3399cc"
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
      
    } catch (err) {
      console.error("Error initiating Razorpay payment:", err);
      setError("An error occurred while processing the payment.");
    }
  };

  const OrderDetails = ({ checkoutresp }) => {
    return (
      <div>
        <h3>Below is the Order Details</h3>
        <p>Order ID: {checkoutresp.id}</p>
        <p>Name: {checkoutresp.name}</p>
        <p>Email: {checkoutresp.email}</p>
        <p>Address: {checkoutresp.address}</p>
        <p>City: {checkoutresp.city}</p>
        <p>State: {checkoutresp.state}</p>
        <p>Zip Code: {checkoutresp.zip_code}</p>
        <p>Phone: {checkoutresp.phone}</p>
        <p>Amount: {checkoutresp.amount}</p>
        <p>Payment Status: {checkoutresp.payment_status}</p>
        <p>Created At: {new Date(checkoutresp.created_at).toLocaleString()}</p>
        <p>Updated At: {new Date(checkoutresp.updated_at).toLocaleString()}</p>
      </div>
    );
  };

  return (
    <div>
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>{error}</p>
      ) : isLoggedIn ? (
        <div>
          <Navbar toggleTheme={toggleTheme} handleLogout={handleLogout} finalizeCart={finalizeCart} />
          <br />
          <h2 style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>One of our representatives will contact you shortly</h2>
          <div className="form-container">
            {latestOrder ? (
              <>
                <OrderDetails checkoutresp={latestOrder} />
                {latestOrder.payment_status !== 'Successful' && (
                <button onClick={() => handleRazorpayPayment(latestOrder)}>Pay Now</button>
              )}

              </>
            ) : (
              <p>No orders found.</p>
            )}
          </div>
        </div>
      ) : (
        <Link to="/login">Please login</Link>
      )}
    </div>
  );
};

export { Payments };
